import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  // État local pour gérer le formulaire si besoin
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // Action du formulaire (démonstration) - 
  // Ici, on se contente d'une alerte ou d'une console.log
  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Merci ${formData.nom}, votre message est bien reçu !`);
    // Ou envoi réel si tu mets en place un backend ou EmailJS, etc.
    setFormData({ nom: '', email: '', message: '' });
  };

  return (
    <div className="contact-container">
      <h1 className="contact-title fade-in-up">Contact</h1>

      {/* Coordonnées directes */}
      <div className="contact-info fade-in-up">
        <p><strong>Téléphone :</strong> <a href="tel:0785424671">0785424671</a></p>
        <p><strong>Email :</strong> 
          <a href="mailto:matheo.teyssier.pro@gmail.com"> matheo.teyssier.pro@gmail.com</a>
        </p>
      </div>

      {/* Formulaire de contact */}
      <div className="contact-form-wrapper fade-in-up">
        <h2>Envoyez-moi un message</h2>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="nom">Nom</label>
            <input
              type="text"
              name="nom"
              id="nom"
              value={formData.nom}
              onChange={handleChange}
              required
              placeholder="Votre nom"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Adresse email</label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Votre email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              name="message"
              id="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Votre message..."
            />
          </div>

          <button type="submit" className="contact-submit-btn">
            Envoyer
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
